module.exports = __webpack_public_path__ + "img/rights-btn.690b9bf5.png";